export default __webpack_public_path__ + "media/plus/password-visual-mobile-16ad41c5.svg";